import AlarmAPI from '../AlarmAPI';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { useMemo } from 'react';
import { useAppSelector } from '../../store.model';
import { ALARMS_POLLING_INTERVAL, AlarmState } from '../Alarm.model';
import { getFeatureToggle } from '../../../shared/featureToggle';

type Options = Parameters<UseQuerySubscription<any>>[1];

function useAlarmsByWorkspace(
  workspaceId: string | undefined,
  options: Options = {}
) {
  const featureToggle = useAppSelector(getFeatureToggle);
  const { data: alarmsData, ...restAlarmAPI } =
    AlarmAPI.useQueryMyIncidentByWorkspaceIdQuery(
      {
        workspaceId: workspaceId || '',
        params: { state: AlarmState.NEW, page_size: 1000 },
      },
      {
        skip: !workspaceId,
        pollingInterval: ALARMS_POLLING_INTERVAL,
        ...options,
      }
    );

  const data = useMemo(
    () =>
      alarmsData?.data.filter(
        (alarm) =>
          !featureToggle.HideDisconnectionAlarms ||
          (featureToggle.HideDisconnectionAlarms && alarm?.event !== '_disconn')
      ),
    [alarmsData, featureToggle.HideDisconnectionAlarms]
  );

  return {
    ...restAlarmAPI,
    allAlarms: alarmsData?.data,
    data,
  };
}

export default useAlarmsByWorkspace;
